﻿require(['ko', '_', 'search/tile', 'search/result', 'bindings/slideDown'], function (ko, _, tileViewModel, resultViewModel) {
    var categoryTreeVm = copyTree(categoryTree, 1);

    window.ko = ko;
    window.knockout = ko;
    ko.options.deferUpdates = true;
    // todo: do not map facets here
    var result = new resultViewModel('category', term, products, pages, currentPage, resultCount, facets, favorites, restrictedFacets, undefined, categoryTreeVm, currentCategory);
    
    ko.applyBindings(result, document.querySelector('.HolyGrail-body'));
    window.result = result;
});